export default function Configure($stateProvider) {
    $stateProvider.state('refsaisieenv', {
        parent: 'common',
        url: '/refsaisieenv',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.ENVIRONNEMENT" | translate }}'
        }
    });

    $stateProvider.state('refsaisieenv.list', {
        url: '/list',
        template: '<trames-saisies></trames-saisies>',
        rights: { domain: 'refsaisieenv', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv',
            label: '{{ "TRAMES.BREADCRUMBS.TRAMES_LIST" | translate}}'
        },
        navigation: {
            menu: 'environnement_theme_mes',
            translate: 'TRAMES.BREADCRUMBS.TRAMES_LIST',
            order: 6
        },
        search: 'TRAMES.BREADCRUMBS.TRAMES_LIST'
    });

    $stateProvider.state('refsaisieenv.list.detail', {
        url: '/{id}',
        template: '<trame-saisie-detail></trame-saisie-detail>',
        rights: { domain: 'refsaisieenv', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('refsaisieenv.new', {
        url: '/new',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisieenv', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        search: 'TRAMES.BREADCRUMBS.TRAME_NEW'
    });

    $stateProvider.state('refsaisieenv.edit', {
        url: '/{id}/edit',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisieenv', right: 'update' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_EDIT" | translate }}'
        }
    });

    $stateProvider.state('refsaisieenv.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'refsaisieenv.new' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('refsaisieenv.duplicate', {
        url: '/{id}/duplicate',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisieenv', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisieenv.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
